import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig.js";

export default function Clinic() {
  useSEO(seoConfig.clinic);

  return (
    <section className="contacts clinic">
      <Breadcrumbs />
      <h1 className="contacts__title history__title">Клиника</h1>

      <div className="footer__middle_block">
        <Link to="/clinic/hospital" className="footer__link">
          Высокотехнологичная медицинская помощь
        </Link>
        <Link to="/clinic/specialized-medical" className="footer__link">
          Специализированная медицинская помощь
        </Link>
        {/* <Link to="/clinic/day-hospital" className="footer__link">
          Дневной стационар
        </Link>
        <Link to="/clinic/consultative" className="footer__link">
          Консультативно-диагностическое отделение
        </Link>
        <Link to="/clinic/laboratory" className="footer__link">
          Лаборатория
        </Link> */}
        <Link to="/clinic/working-chief" className="footer__link">
          Работа с главными врачами кожно-венерологических учреждений
        </Link>
        <Link to="/clinic/problem-syphilis" className="footer__link">
          Консультативный совет по проблеме сифилис
        </Link>
      </div>
    </section>
  );
}
